import { HeadCell } from 'models/TableProps';
import {
    MyQuotationsHeadCellContent,
    QuotationsHeadCellContent,
} from '../../../models/Quotations';

export const QUOTATION_HEAD_CELLS: HeadCell<QuotationsHeadCellContent>[] = [
    {
        id: 'quoteID',
        numeric: false,
        disablePadding: true,
        label: 'QUOTE_ID',
        sortable: true,
    },
    {
        id: 'billToCustomerName',
        numeric: false,
        disablePadding: false,
        label: 'CUSTOMER_NAME',
        sortable: true,
    },
    {
        id: 'count',
        numeric: false,
        disablePadding: false,
        label: 'COUNT',
        sortable: true,
    },
    {
        id: 'orderDate',
        numeric: false,
        disablePadding: false,
        label: 'ORDER_DATE',
        sortable: true,
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'ACTIONS',
        sortable: false,
    },
    {
        id: 'more',
        numeric: false,
        disablePadding: false,
        label: 'MORE',
        sortable: false,
    },
];

export const MY_QUOTATION_HEAD_CELLS: HeadCell<MyQuotationsHeadCellContent>[] =
    [
        {
            id: 'quoteID',
            numeric: false,
            disablePadding: true,
            label: 'QUOTE_ID',
            sortable: true,
        },
        {
            id: 'count',
            numeric: false,
            disablePadding: false,
            label: 'COUNT',
            sortable: true,
        },
        {
            id: 'orderDate',
            numeric: false,
            disablePadding: false,
            label: 'ORDER_DATE',
            sortable: true,
        },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'STATUS',
            sortable: true,
        },
        {
            id: 'more',
            numeric: false,
            disablePadding: false,
            label: 'MORE',
            sortable: false,
        },
    ];
